<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :nombre="nombre"
          :documentoNumero="documentoNumero"
          :incluirInactivos="incluirInactivos"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Clientes">
          <b-table hover
              responsive="sm" 
              class="registro"
              :items="clientes" 
              :fields="itemFields"
              :busy="tableBusy"
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              

            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos del Cliente</b-dropdown-item>

                <b-dropdown-item @click.stop="consultarContactos(data.item)">
                  <i class="fa fa-user"></i>Consultar Contactos</b-dropdown-item>

                <!--
                <b-dropdown-item @click.stop="consultarAcciones(data.item)">
                  <i class="fa fa-list"></i>Consultar Acciones</b-dropdown-item>
                -->

                  <!--
                <b-dropdown-item @click.stop="borrar(data.item)">
                  <i class="fa fa-remove"></i>Borrar</b-dropdown-item>
                  -->
              </b-dropdown>

            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item 
              @click.stop="agregar">
            <i class="fa fa-plus"></i>Nuevo Cliente</b-dropdown-item>
          <b-dropdown-item
              @click.stop="exportXls">
            <i class="fa fa-file-excel-o"></i>Exportar Listado de Clientes</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'clientes/getField',
  mutationType: 'clientes/updateField',
});

export default {
  name: 'Clientes',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      itemFields: [
        {
          key: 'nombreComercial',
          sortable: true
        },
        {
          key: 'razonSocial',
          sortable: true
        },
        { key: 'telefono' },
        { key: 'celular' },
        { key: 'email' },
        {
          key: 'opciones',
          label: '',
          class: "text-center"
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'clientes',
      'nombre',
      'documentoNumero',
      'incluirInactivos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas'
    ]),
  },
  created() {
    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.nombre = filtro.nombre;
      this.documentoNumero = filtro.documentoNumero;
      this.incluirInactivos = filtro.incluirInactivos;
      this.paginaActual = 1;

      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('clientes/getClientes')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    consultar (item) {
      this.$router.push({ name: 'ClienteDatos', 
                          params: { id: item.id }})
    },
    consultarContactos (item) {
      this.$router.push({ name: 'ClientesContactos', 
                          params: { clienteId: item.id }})
    },
    editar (item) {
      this.$router.push({ name: 'ClienteABM', 
                          params: { id: item.id }})
    },
    borrar (item) {
      this.modalDisabled = true
    },
    agregar () {
      this.$router.push({ name: 'ClienteABM', 
                          params: { id: 0 }})
    },
    exportXls () {
      this.showSpinner();
      this.$store.dispatch('clientes/getRptClientes')
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptClientes = this.$store.getters['clientes/rptClientes'];

          if (rptClientes) {
            if (rptClientes.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Listado de Clientes';
            let fileName = 'clientes';
            let format = [
              { titulo: 'Código', nombre: 'id', formato: '' },
              { titulo: 'Razón Social', nombre: 'razonSocial', formato: '' },
              { titulo: 'Nombre Comercial', nombre: 'nombreComercial', formato: '' },
              // { titulo: 'Pais', nombre: 'pais', formato: '' },
              // { titulo: 'Provincia', nombre: 'provincia', formato: '' },
              // { titulo: 'Localidad', nombre: 'localidad', formato: '' },
              { titulo: 'Teléfono', nombre: 'telefono', formato: '' },
              { titulo: 'Celular', nombre: 'celular', formato: '' },
              { titulo: 'Email', nombre: 'email', formato: '' },
              { titulo: 'Inactivo', nombre: 'inactivo', formato: 'bool' }
            ];

            this.exportXLS(title, fileName, rptClientes, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems() 
      }
    },    
  }    
}
</script>

<style>
</style>
